import { ConfigStore } from '../../service-setup/ConfigStore';
import { diContainer, serviceNames } from '../../service-setup/diContainer';
import { IReviewsPayload } from '../interfaces/IReviews';

export class WriteReviewClickedUseCase {
    private reviewInfo: IReviewsPayload;
    private configStore: ConfigStore;
    constructor(reviewInfo: IReviewsPayload) {
        this.configStore = diContainer.get(serviceNames.configStore);
        this.reviewInfo = reviewInfo;
    }
    public execute = () => {
        const config = this.configStore.config;
        const reviewWrapperUrl =
            config.ratingsReviewsConfig && config.ratingsReviewsConfig.reviewWrapperUrl;
        const createReviewLink: HTMLElement | null = document.querySelector(
            '.pr-snippet-write-review-link'
        );
        const { reviewInfo } = this;
        const reviewLink = reviewInfo && reviewInfo.reviewLink;
        const defaultReviewPath = `${reviewWrapperUrl}?pr_page_id=${reviewInfo.id}`;
        if (createReviewLink) {
            createReviewLink.click();

            return;
        }
        window.location.assign(reviewLink || defaultReviewPath);
    };
}
